export default __webpack_public_path__ + "static/media/control-skin-danta.711d8025.png";